import { z } from 'zod'

import { emailSchema } from './emailSchema'

/**
 * Pickup Person Information schema
 */
export const pickupPersonInformationSchema = z
  .object({})
  .merge(emailSchema)
  .merge(
    z.object({
      firstname: z
        .string()
        .trim()
        .min(1, { message: 'This is a required field.' })
        .max(255, 'Please enter less or equal than 255 symbols.')
        .regex(/^[A-Za-z]+$/, 'Only letters allowed'),
      lastname: z
        .string()
        .trim()
        .min(1, { message: 'This is require field.' })
        .max(255, 'Please enter less or equal than 255 symbols.')
        .regex(/^[A-Za-z]+$/, 'Only letters allowed'),
      telephone: z
        .string()
        .trim()
        .min(1, { message: 'This is required field.' })
        .max(20, 'Phone number is too long'),
    }),
  )

// 导出 Pickup Person Information 表单类型
export type TPickupPersonInformation = z.infer<typeof pickupPersonInformationSchema>
